// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const RegisteredContextsTable: MarkdocTagRegistration = {
  tag: 'registered-contexts-table',
  component: 'RegisteredContextsTable',
  attributes: {
    contexts: {
      type: Object,
      description:
        'An hash of {name: ContextDocumentation} to display in the table',
    },
  },
};
